import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrodownComponent } from './drodown.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';

@NgModule({
  imports: [
    CommonModule,
    NzDropDownModule,
    NzIconModule
  ],
  declarations: [DrodownComponent],
  exports: [DrodownComponent]
})
export class DrodownModule { }
